import RestoreLifeManager from './RestoreLifeManager';

export default RestoreLifeManager;
export { RestoreLifeManager };
